import { isMaldivesCharterBundleOffer } from 'lib/charterFlights/charterBundleOfferPageUtils'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'

/**
 * Flash offers with multiple stay lengths and both a check-in and a check-out. Single-length
 * offers, anytime pages and incomplete stays keep the existing calendar behaviour. Charter
 * identity uses the existing bundle classifier, with flights optional so hotel-only
 * offers still match, plus the page route which stays set when the bundle switch is off.
 */
export function isFlashOfferLosCalendarEligible(
  offer: App.AnyOffer | undefined,
  charterBundleRoute?: App.CharterBundleRoute,
  selectedStay?: { checkIn?: string, checkOut?: string },
): boolean {
  const hasSelectedStay = !!selectedStay?.checkIn && !!selectedStay?.checkOut
  return hasSelectedStay &&
    isFlashHotelOffer(offer) &&
    offer.packages.some(pkg => pkg.duration !== offer.packages[0]?.duration) &&
    !charterBundleRoute &&
    !isMaldivesCharterBundleOffer(offer, true, { requireFlightsEnabled: false })
}
